import React from 'react';
import PropTypes from 'prop-types';

import Image from '@components/Image';
import useProductImage from '@hooks/images/useProductImage';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';
import headerPlaceholder from '@assets/images/loading-header.png';
import { PRODUCT_CLICK_LOCATION } from '@conversion/constants';
import Container from './ImageContainer';

function ProductItemImage({ image, size, className }) {
  const src = useProductImage({ image, size });
  const isDesktopLayout = useIsDesktopLayout();

  return (
    <Container className={className} isDesktopLayout={isDesktopLayout}>
      <Image
        id={PRODUCT_CLICK_LOCATION.PHOTO}
        src={src}
        placeholder={headerPlaceholder}
        customClass="productItemImage__container"
        alt="product"
        showErrorImage
        ariaHidden
      />
    </Container>
  );
}

ProductItemImage.propTypes = {
  image: PropTypes.string,
  size: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ProductItemImage;
